import { usePriceLive } from '@ui/hooks/price/usePriceLive';

import { useTradingPair } from '../store/useTradingPair';

export const useMarketPrice = () => {
  const tradingTokenBaseSymbol = useTradingPair(
    (s) => s.useTradingPair().baseSymbol,
  );

  const price = usePriceLive(tradingTokenBaseSymbol);

  // close is latest
  return price?.toNumber();
};
